import { Pipe, PipeTransform } from '@angular/core';


/**
 * 
 * Pipe dedicado obtener intervalo de tiempo que dura un servicio
 */

@Pipe({
    name: 'intervaloTiempoServicio' // nombre del pipe en las directivas
})

export class IntervaloTiempoServicioPipe implements PipeTransform{


    // Métdodo a implementar siempre
    transform(inicio:any, fin:any):any{
    	var msecPerMinute = 1000 * 60;
	    var msecPerHour = msecPerMinute * 60;
	    var msecPerDay = msecPerHour * 24;

	    // Obtener la diferencia en milisegundos
	    var interval = new Date(fin).getTime() - new Date(inicio).getTime();
	    // Calcular cuentos días contiene el intervalo. Substraer cuantos días
	    //tiene el intervalo para determinar el sobrante
	    var days = Math.floor(interval / msecPerDay );
	    interval = interval - (days * msecPerDay );

	    // Calcular las horas , minutos y segundos
	    var hours = Math.floor(interval / msecPerHour );
	    interval = interval - (hours * msecPerHour );

	    var minutes = Math.floor(interval / msecPerMinute );
	    interval = interval - (minutes * msecPerMinute );

	    if(isNaN(days) || isNaN(hours) || isNaN(minutes) ){
	    	return 0 + " días";
	    }
    	
	    return days + " días, " + hours + " horas, " + minutes + " minutos.";
    }
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/intervalo-tiempo-servicio.pipe.ts